<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="page_iv"></a> </p>
<p class="copy"> </p>
<p class="copy"> </p>
<p class="copy"> </p>
<p class="copy"> </p>
<p class="copy1">First published in 2022 by</p>
<p class="copy">Birlinn Limited</p>
<p class="copy">West Newington House</p>
<p class="copy">10 Newington Road</p>
<p class="copy">Edinburgh</p>
<p class="copy">EH9 1QS</p>
<p class="copy1"><em><a href="http://www.birlinn.co.uk" target="_blank">www.birlinn.co.uk</a></em></p>
<p class="copy1">Copyright © Andrew B.T. Liddle, 2022</p>
<p class="copy1">ISBN 978-1-78027-789-9<br/>EBOOK ISBN 978-1-78885-535-8</p>
<p class="copy1">The right of Andrew Liddle to be identified as the author of this work has been asserted by</p>
<p class="copy">him in accordance with the Copyright, Designs and Patents Act, 1988</p>
<p class="copy1">British Library Cataloguing-in-Publication Data</p>
<p class="copy1">A catalogue record of this book is available on request from the British Library</p>
<p class="copy1">Typeset by Hewer Text UK Ltd, Edinburgh</p>
<p class="copy1">Papers used by Birlinn are from well-managed forests and other responsible sources</p>
<p class="copy1">Printed and bound by Clays Ltd, Elcograf S.p.A.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0ba981a6